export default {
    home_page_title: "ข้อมูลบัญชี",
    security_page_title: "ศูนย์ความปลอยภัย",
    security_setting_page_title: "ศูนย์ความปลอยภัย",
    security_phone_label: "โทรศัพท์",
    security_email_label: "อีเมล",
    security_question_label: "คำถามรักษาความปลอดภัย",
    security_unset_text: "ยังไม่ได้ตั้งค่า",
    security_setted_text: "Set",
    security_question_options: [
        "ชื่อนามสกุลของมารดา?",
        "วันเกิดของคู่สมรสของคุณคือ?",
        "ชื่อนามสกุลของบิดา?",
        "หมายเลขประจำตัวนักเรียน（หรือทำงาน）คือ?",
        "เพื่อนสนิทในตอนเด็กคือใคร?",
        "บุคคลที่มีอิทธิพลต่อคุณมากที่สุดชื่ออะไร?"
    ],
    password_lost_page_title: "ลืมพาสเวิร์ด",
    password_reset_page_title: "แก้ไขรหัสผ่าน",
    password_lost_account_placeholder: "กรุณากรอกบัญชีที่ลืมรหัสผ่าน",
    empty_lost_account_tips: "เว้นว่างชื่อบัญชีไม่ได้",
    iscorrect_lost_account_tips: "User does not exist",
    password_reset_new_placeholder: "พาสเวิร์ดใหม่",
    password_reset_confirm_placeholder: "ยืนยันพาสเวิร์ด",
    password_verify_page_title: "ยืนยันตัวตน",
    phone_verify_page_title: "ยืนยันตัวตน",
    email_verify_page_title: "ยืนยันตัวตน",
    question_verify_page_title: "ยืนยันตัวตน",
    phone_reset_page_title: "โทรศัพท์",
    email_reset_page_title: "อีเมล",
    question_reset_page_title: "คำถามรักษาความปลอดภัย",
    phone_binding_text: "บัญชีของคุณได้ผูกกับหมายเลขโทรศัพท์",
    email_binding_text: "บัญชีของคุณได้ผู้เข้ากับอีเมล",
    verification_code_text: "รหัสยืนยัน",
    resend_text: "ส่งอีกครั้ง",
    empty_phone_number_tips: "กรุณาใส่เบอร์โทรศัพท์มือถือ",
    iscorrect_phone_number_tips: "Please enter a valid phone number",
    empty_verification_code_tips: "กรุณาใส่รหัสยืนยัน",
    iscorrect_verification_code_tips: "รหัสยืนยันผิดพลาด",
    password_placeholder: "พาสเวิร์ด",
    empty_password_tips: "กรอกพาสเวิร์ด",
    iscorrect_password_tips: "รหัสไม่ถูกต้อง",
    mismatched_rule_password_tips:
        "รหัสผ่านต้องไม่มีสัญลักษณ์ &、#、หรือการเว้นเคาะบรรทัด",
    different_confirm_password_tips: "รหัสผ่านไม่ตรงกัน",
    empty_email_tips: "กรุณาใส่ที่อยู่อีเมล",
    iscorrect_email_tips: "อีเมลไม่ถูกต้อง",
    answer_placeholder: "คำตอบ",
    empty_question_tips: "Choose a security question",
    empty_answer_tips: "Give your answer here",
    iscorrect_answer_tips: "Wrong answer",
    next_step_text: "ถัดไป",
    submit_text: "Submit",
    submit_success_tips: "Success",
    submit_error_tips: "Operation failed, please try again",
    get_data_fail_tips: "อินเตอร์เนตผิดปกติ กรุณาลองใหม่",
    use_other_verification_type_text: "รูปแบบการยืนยันอื่นๆ",
    custom_support_notice:
        "บัญชีของคุณยังไม่มีการรักษาความปลอดภัยใดใด คุณสามารถเปิดหน้าเว็บนี้จาก PC เพื่อดำเนินการ" +
        process.env.VUE_APP_ORIGIN_PROFILE
};
